module.exports = __webpack_public_path__ + "static/media/mouse_1.41fe1c9c.svg";